import React from 'react';

const ContractStatus = ({ whitelistMint, publicMint, isWhitelisted }) => {
    return (
        <div className="flex flex-col gap-2 text-sm text-primary mb-4 pt-4 custom-font">
            <div>
                Whitelist: {whitelistMint ? "Active" : "Inactive"}
                {whitelistMint && isWhitelisted && " (You are whitelisted)"}
            </div>
            <div>
                Public: {publicMint ? "Active" : "Inactive"}
            </div>
        </div>
    );
};

export default ContractStatus;